import {
  WSButton,
  WSElement,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useEffect, useRef } from "react";
import poweredByWingspan from "../../../assets/images/poweredByWingspan.svg";
import { useWSStore } from "../../../store";
import { WS_LINKS } from "../../../types/wsLinks";
import { openIntercom } from "../../utils/intercom";
import styles from "./index.module.scss";
import { useRefDimensions } from "../../../utils/useRefDimensions";

type Props = {
  showContactSupport?: boolean;
  showLinks?: boolean;
  showAdditionalInfo?: boolean;
  className?: string;
  onChangeFooterHeight?: (height: number) => void;
};

export const AppFooter: React.FC<Props> = ({
  showContactSupport = true,
  showLinks = true,
  showAdditionalInfo = true,
  className,
  onChangeFooterHeight
}) => {
  const footerRef = useRef<HTMLElement | null>(null);
  const footerDimensions = useRefDimensions(footerRef);

  const {
    appContext: { isEmbedded }
  } = useWSStore();

  useEffect(() => {
    onChangeFooterHeight?.(footerDimensions.height);
  }, [footerDimensions.height]);

  return (
    <WSElement className={className} ref={footerRef} as="footer">
      <WSFlexBox.Center direction="column" py="2XL" px="M">
        {/* Contact support is hidden in embedded contexts — integrators own
            their own support channels. "Powered by Wingspan" (showLinks) stays. */}
        {showContactSupport && !isEmbedded && (
          <WSText.ParagraphSm p="M">
            Need help?
            <WSButton.Link
              ml="XS"
              className={styles.helpLink}
              size="M"
              onClick={openIntercom}
            >
              Contact support
            </WSButton.Link>
          </WSText.ParagraphSm>
        )}
        {showLinks && (
          <WSFlexBox.Center gap="S" pt="M" pb="S">
            <img src={poweredByWingspan} alt="Powered By Wingspan" />
            <WSElement className={styles.splitter} />
            <WSButton.Link
              size="S"
              onClick={() => window.open(WS_LINKS.wingspanTosAcceptance)}
              textClassName={styles.externalLink}
            >
              Terms
            </WSButton.Link>
            <WSButton.Link
              size="S"
              onClick={() =>
                window.open(WS_LINKS.wingspanPrivacyPolicyAcceptance)
              }
              textClassName={styles.externalLink}
            >
              Privacy
            </WSButton.Link>
          </WSFlexBox.Center>
        )}
        {showAdditionalInfo && (
          <WSText.ParagraphXs color="gray500">
            Wingspan is a financial services technology company and is not a
            bank. Banking services provided by Lead Bank, Member FDIC.
          </WSText.ParagraphXs>
        )}
      </WSFlexBox.Center>
    </WSElement>
  );
};
